import React from 'react'

export default props => (
    <div className='card-header' style={{ ...props.style, padding: 8, paddingBottom: props.paddingBottom }}>
        {props.children}
    </div>
)
